// extracted by mini-css-extract-plugin
export default {"root":"PreviewIcon_root__RbSb4","icon":"PreviewIcon_icon__MLI7e"};